import { ResizeObserver } from '@juggle/resize-observer';
import useMeasure from 'react-use-measure';

export const useMeasurePolyfill = () => {
  return useMeasure({ polyfill: ResizeObserver });
};
